import { useState } from "react";
import { S3PostData } from "api-client";

export const useUploadToS3 = () => {
  const [status, setStatus] = useState<
    "idle" | "uploading" | "success" | "error"
  >("idle");
  const [error, setError] = useState<string | null>(null);

  const uploadFiles = async (files: File[], presignedPosts: S3PostData[]) => {
    setStatus("uploading");
    setError(null);

    try {
      const uploadResults = await Promise.all(
        files.map(async (file, i) => {
          const presigned = presignedPosts[i];

          const formData = new FormData();
          Object.entries(presigned.fields).forEach(([key, value]) => {
            formData.append(key, value);
          });

          formData.append("file", file);

          const res = await fetch(presigned.url, {
            method: "POST",
            body: formData,
          });

          if (!res.ok) {
            throw new Error(`Failed to upload ${file.name}`);
          }

          return {
            file_id: presigned.file_id,
            file_name: presigned.file_name,
            status: "success" as const,
            url: `${presigned.url}${presigned.fields.key}`,
          };
        })
      );

      setStatus("success");
      return uploadResults;
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      setError(message);
      setStatus("error");
      throw err;
    }
  };

  return { status, error, uploadFiles };
};
